import React, {Component} from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {deselectItem, selectItem, updateItem, toggleMoreButton} from '../../../actions/contents/keyword';
import ItemCheckbox from "../../common/EntryItemCheckbox";
import * as querystring from "query-string";
import {jsonResponseHandler} from '../../../utils/FetchHelper'
import * as StatusTypes from "../../../constants/contents/EntryStatusTypes";
import KeywordListItemButton from "./KeywordListItemButton";
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
}), dispatch => ({
    handleSelectItem: (id) => {
        dispatch(selectItem(id))
    },

    handleDeselectItem: (id) => {
        dispatch(deselectItem(id))
    },
    handleUpdateItem: (item) => {
        dispatch(updateItem(item))
    },
    toggleMoreButton: (itemId) => {
        dispatch(toggleMoreButton(itemId))
    },
    dispatch
}))
class KeywordListItem extends Component {

    constructor() {
        super();

        this.handleSelect = this.handleSelect.bind(this);
        this.handleHidden = this.handleHidden.bind(this);
        this.handleVisible = this.handleVisible.bind(this);
        this.updateItem= this.updateItem.bind(this);
        this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);

    }

    handleSelect(e) {
        const { item, handleSelectItem, handleDeselectItem } = this.props;

        if (item.selected) {
            handleDeselectItem(item.id)
        } else {
            handleSelectItem(item.id)
        }
    }

    handleVisible(item) {
        item.visibility = StatusTypes.PUBLIC;
        item.processing = true;
        this.updateItem(item, {visibility: StatusTypes.PUBLIC});
    }

    handleHidden(item) {
        item.visibility = StatusTypes.PRIVATE;
        item.processing = true;
        this.updateItem(item, {visibility: StatusTypes.PRIVATE});
    }

    updateItem(item, changes) {

        const { handleUpdateItem, dispatch } = this.props;

        fetch(addPrefix("/manage/notice/"+item.id+"/visibility.json"), {
            method: "put",
            credentials: "include",
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: querystring.stringify(
                Object.assign({}, changes)
            )
        })
            .then(jsonResponseHandler(dispatch))
            .then(data => {
                item.processing = false;
                handleUpdateItem(item);
            })
            .catch(e => {
                item.processing = false;
                console.log(e)
            })
    }



    alertBlindMessage(event, message) {
        alert(message);
        event.preventDefault();
    }

    //  Mouse leave 이벤트에 열린 레이어를 닫기위해 toggle값을 -1 default값으로 셋팅한다.
    mouseLeaveHandler(){
        this.props.toggleMoreButton(-1);
    }

    renderTitle(item) {
        if (item.isRestrict) {
            return <strong className="tit_post tit_ellip">
                <a href={item.permalink} target="_blank" className="link_cont" title={item.title}>
                    {this.renderRestrictDisplay(item)}
                    {item.title}
                </a>
                {this.renderHasFile(item)}
            </strong>
        }
        else {
            return <strong className="tit_post tit_ellip">
                <a href={(item.deleting) ? "#" : addPrefix(item.permalink)} title={item.title} className="link_cont"
                   target="_blank">
                    {item.title}
                </a>
                {this.renderHasFile(item)}
            </strong>
        }
    }


    renderHasFile(keyword) {
        if(keyword.hasFile)
            return <span className="ico_blog ico_file"/>
    }

    renderRestrictDisplay(keyword) {
        if (keyword.isRestrict)
            return <span className="info_status">[{keyword.restrictLabel}]</span>
    }

    renderCountOfCommentDisplay(keyword) {
        if (keyword.countOfComments > 0)
            return <span className="txt_info">댓글 {keyword.countOfComments}</span>
    }

    render() {
        const { item } = this.props;
        const status = item.visibility;

        return (
            <li className={classnames({item_dimmed: item.deleting})} onMouseLeave={this.mouseLeaveHandler}>
                <ItemCheckbox item={item} handleSelect={this.handleSelect}/>

                <div className="post_cont">
                    {this.renderTitle(item)}
                    <span className="txt_info fst">{item.author}</span>
                    <span className="txt_info">{item.published}</span>
                    {this.renderCountOfCommentDisplay(item)}
                    {this.renderHasFile(item)}
                </div>

                <div className="post_btn">

                    {status === StatusTypes.PRIVATE && <span className="ico_blog ico_private">비공개</span>}
                    {status === StatusTypes.PROTECTED && <span className="ico_blog ico_secret">보호</span>}

                    <div className="info_btn">
                        <KeywordListItemButton
                            item={item}
                            handleHidden={this.handleHidden}
                            handleVisible={this.handleVisible}
                        />
                    </div>
                </div>
            </li>
        );
    }
}

export default KeywordListItem;
